import { createExportHandlers } from '@src/main/modules/messages/utils/createExportHandlers';
import { normalizeFlightEvaluationReport } from '@src/main/modules/messages/utils/formatters';
import { BriefFlightEvaluation } from '@src/main/modules/reports/shared/domain/evaluation.interface';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFlightEvaluationExport = (
  evaluations: BriefFlightEvaluation[],
  fileName: string,
) => {
  const { t } = useTranslation();

  return useMemo(
    () => createExportHandlers(evaluations, normalizeFlightEvaluationReport, fileName, t),
    [evaluations, fileName, t],
  );
};
